import type { RouteTrafficMentionColor$options } from '$houdini';

export const SELECTED_INNER_LINE_WIDTH = 6;
export const SELECTED_OUTTER_LINE_WIDTH = 10;
export const UNSELECTED_INNER_LINE_WIDTH = 6;
export const UNSELECTED_OUTTER_LINE_WIDTH = 10;

export const layout: maplibregl.LineLayerSpecification['layout'] = {
	'line-cap': 'round',
	'line-join': 'round',
};

export const trafficLineColor: Record<Lowercase<RouteTrafficMentionColor$options>, string> = {
	orange: '#FFAA00',
	red: '#E60000',
	black: '#000000',
};

export const lineColor: Record<string, string> = {
	viamichelin: '#1095F9',
	dark: '#052D4B',
	lightViamichelin: '#E9EEF5',
};
